import React from 'react';
import { useTranslation, initReactI18next } from "react-i18next";
import { Col, Row, Button } from "reactstrap";
import i18n from '../../../i18n';
import { Trans } from "react-i18next";
import { Page, TransparentPage, SheetOfPaper } from "../../../components/Page/Page";
import Chapter from "../../../components/Chapter/Chapter";
import SourceHeader from "../../../components/SourceHeader/SourceHeader";

import routes from './c05_routes.js';
import ENTranscriptPDF from './Transcripts/en/en_c5_p18.pdf';
import NOTranscriptPDF from './Transcripts/no/no_c5_p18.pdf';
import DocumentIMG from './Media/c5_p18.jpg';

const C05P18 = (props) => {
	const { t } = useTranslation();
	const translation_namespace = 'c05_p18';

	return (
		<Chapter pages={routes} chapterName={props.chapterName} currentPageYear={props.year}>
			<Page className="C05P18">
				<TransparentPage>
					<p><img src={ DocumentIMG } alt={ t('Image of the original document transcribed next') } /></p>
					<ul className="download-links">
						<li><a href={ i18n.language === 'nb-NO' ? NOTranscriptPDF : ENTranscriptPDF } target="_blank"><Trans>Download</Trans> pdf <Trans>file</Trans></a></li>
						<li><a href={DocumentIMG} target="_blank"><Trans>Download</Trans> <Trans>image file</Trans></a></li>
					</ul>
				</TransparentPage>
				<SheetOfPaper>
					<SourceHeader name={ props.name } chapterName={ props.chapterName } />
					<p>
						<strong><Trans ns={ translation_namespace }>Card for Liesbeth Grabowski in card index of deported Jews, Cej series ”Refugees/deported Jews/books of statistics” in the Central Passport Office’s archives. The National Archives in Oslo.</Trans></strong>
					</p>
					<h2><Trans>Transcript</Trans>:</h2>
					<div className="transcript">
						<p>
							<Trans ns={ translation_namespace }>Trondheim Police Station</Trans><br />
							<Trans ns={ translation_namespace }>The Register of Aliens</Trans>
						</p>
						<p>
							<Trans ns={ translation_namespace }>[in field to the left:]</Trans><br />
							<Trans ns={ translation_namespace }>Name: Grabowski, Lisbeth</Trans><br />
							<Trans ns={ translation_namespace }>Position: Cantor’s wife</Trans><br />
							<Trans ns={ translation_namespace }>Born: April 30th, 1920 in Gleiwitz, Germany</Trans><br />
							<Trans ns={ translation_namespace }>Domicile: Gleiwitz</Trans><br />
							<Trans ns={ translation_namespace }>Citizenship: German (J.)</Trans><br />
							<Trans ns={ translation_namespace }>Arrived in Norway: November 2nd, 1939 from Germany</Trans><br />
							<Trans ns={ translation_namespace }>Place of residence in Norway: ...</Trans><br />
							<Trans ns={ translation_namespace }>Report book issued: ... by ...</Trans><br />
							<Trans ns={ translation_namespace }>Married to: December 4th, 1938 to cantor Josef Israel Grabowski</Trans><br />
							<Trans ns={ translation_namespace }>Children under the age of 21 living at home: ...</Trans>
						</p>
						<p>
							<Trans ns={ translation_namespace }>[in field to the right:]</Trans><br />
							<Trans ns={ translation_namespace }>Place of residence (refugees). When. Where:</Trans><br />
							<Trans ns={ translation_namespace }>November 5th, 1939 Innherredsveien 9, 4.</Trans>
						</p>
						<p>
							<Trans ns={ translation_namespace }>[written in pencil over both fields:]</Trans><br />
							<Trans ns={ translation_namespace }>Jew Regarded as deceased</Trans>
						</p>
					</div>
				</SheetOfPaper>
			</Page>
		</Chapter>
	);
};

export default C05P18;